import { SimpleSelect } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

import { SimpleSelectProps } from '../../../../../toolkit-sui/dist/components/SimpleSelect/types.ts';

type ThreeTierQualityInputProps = Pick<
  SimpleSelectProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required'
> & {
  poolOrSpaQualityLabel?: boolean;
};

export const ThreeTierQualityInput = forwardRef<HTMLSelectElement, ThreeTierQualityInputProps>(
  ({ poolOrSpaQualityLabel, ...props }, ref) => {
    return (
      <SimpleSelect ref={ref} size="sm" {...props}>
        {[
          [poolOrSpaQualityLabel ? 'Luxury' : 'Good', '1'],
          [poolOrSpaQualityLabel ? 'Better' : 'Average', '2'],
          [poolOrSpaQualityLabel ? 'Standard' : 'Low', '3'],
        ].map(([label, value]) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </SimpleSelect>
    );
  },
);
